module.exports = __webpack_public_path__ + "ad9e23765264b872d9c7c088c9666e4c.png";